/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UrlEntity
 */
export interface UrlEntity {
    /**
     * 
     * @type {string}
     * @memberof UrlEntity
     */
    url: string;
}

/**
 * Check if a given object implements the UrlEntity interface.
 */
export function instanceOfUrlEntity(value: object): value is UrlEntity {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function UrlEntityFromJSON(json: any): UrlEntity {
    return UrlEntityFromJSONTyped(json, false);
}

export function UrlEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): UrlEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function UrlEntityToJSON(json: any): UrlEntity {
    return UrlEntityToJSONTyped(json, false);
}

export function UrlEntityToJSONTyped(value?: UrlEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

